import { render, staticRenderFns } from "./form_v1.vue?vue&type=template&id=4351512e&scoped=true&"
import script from "./form_v1.vue?vue&type=script&lang=js&"
export * from "./form_v1.vue?vue&type=script&lang=js&"
import style0 from "./form_v1.vue?vue&type=style&index=0&id=4351512e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351512e",
  null
  
)

export default component.exports